import { SpectrumIdentityTypeEnum } from '../enums/spectrumBankAccountEnum'
import { MoneyTypeEnum, PaymentMethodEnum, SuscriptionStatusEnum } from './movement.interface'
import { IPaymentStatusEnum } from './payment.interface'
import { ISerie } from './serie.interface'

// POST /suscription/manual/validate-identity
export interface IValidateManualSuscriptionIdentityRequest {
  documentType: SpectrumIdentityTypeEnum
  documentNumber: string
}

export enum ManualSuscriptionContractTypeEnum {
  INDIVIDUAL = '01',
  MANCOMUNADO_CONJUNTO = '02',
  MANCOMUNADO_INDISTINTO = '03',
}

export interface IManualSuscriptionContractType {
  code: ManualSuscriptionContractTypeEnum
  label: string
}

export interface IManualSuscriptionPersonName {
  nombres: string
  apellidoPaterno?: string
  apellidoMaterno?: string
}

export interface IManualSuscriptionContractSummary {
  codParticipe: string
  tipoContrato: IManualSuscriptionContractType
  titular: IManualSuscriptionPersonName
  otrosParticipantes?: IManualSuscriptionPersonName[]
}

export interface IValidateManualSuscriptionIdentityResponse {
  customer_id: string
  contracts: IManualSuscriptionContractSummary[]
}

// GET /suscription/manual/contract-risk-profile/:customer_id
export interface IManualSuscriptionContractRiskProfileResponse {
  risk_profile_id: number
  risk_profile_name: string
}

// GET /suscription/manual/funds/:customer_id
export interface IManualSuscriptionFundRiskProfile {
  id: number
  name: string
}

export interface IManualSuscriptionBank {
  id?: number
  description: string
  code?: string
  status: number
}

export interface IManualSuscriptionCollectorAccount {
  id: number
  title: string
  bank_id: number
  account_type_id: number
  account_type: string
  moneda: MoneyTypeEnum
  cca: string
  cci: string
  ruc: string
  razon_social: string
  fund_id: number
  logo_bank: string
  status: number
  bank: IManualSuscriptionBank
}

export interface IManualSuscriptionFund {
  id: number
  codFund: string
  title: string
  allows_serie_selection: boolean
  risk_profile: IManualSuscriptionFundRiskProfile | null
  is_recommended: boolean
  series: ISerie[]
  collector_accounts: IManualSuscriptionCollectorAccount[]
}

export interface IManualSuscriptionFundsResponse {
  data: IManualSuscriptionFund[]
}

// GET /suscription/manual/amount-min-inversion/:customer_id
export interface IManualSuscriptionAmountMinInversion {
  fund_id: number
  cod_fund: string
  serie_id: number
  serie_cod: string
  amount_min_inversion: number
  moneda: string
}

export interface IManualSuscriptionAmountMinInversionResponse {
  data: IManualSuscriptionAmountMinInversion[]
}

// GET /suscription/via/list
export interface IManualSuscriptionVia {
  id: number
  description: string
  code: string | null
  status: number
}

export interface IManualSuscriptionViaListResponse {
  data: IManualSuscriptionVia[]
}

// POST /suscription/create-manual
export interface ICreateManualSuscriptionRequest {
  documentType: SpectrumIdentityTypeEnum
  documentNumber: string
  codParticipe?: string
  fund_id: number
  serie_cod: string
  amount: number
  collector_account_prudential_id: number
  fund_origin_id: number
  // Only sent when the selected funds origin is "Otros" (code OTHER); max 255 chars
  fund_origin_detail?: string
  via_id: number
  risk_profile_id?: number
}

export interface IManualSuscriptionCustomer {
  id: number
  name: string
  lastname: string
  middlename: string
  surname: string
  email: string
  number_phone: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  channel_register?: string
  number_document?: string
  transac_id?: string
}

export interface ICreatedManualSuscription {
  id: number
  fund_id: number
  amount: number
  terms_and_conditions: boolean
  customer_id: string
  customer: IManualSuscriptionCustomer
  money_type: MoneyTypeEnum
  status: SuscriptionStatusEnum
  created_at?: string
  payment_url?: string
  payment_token?: string
  payment_method?: PaymentMethodEnum
  scheduled_rescue?: boolean
}

export interface ICreatedManualPayment {
  id: number
  suscription_id: number
  operation_number: string
  voucher: string
  created_at: string
  status: IPaymentStatusEnum
  payment_code_expiration_date?: string
}

export interface ICreateManualSuscriptionResponse {
  data: {
    suscription: ICreatedManualSuscription
    payment: ICreatedManualPayment
  }
}
